export function googleMap() {
    let marker;
    let map;
    let locationLat;
    let locationLng;
    const markerImage = $("#map").data("marker");
    $(".map-list .map-item:first").each(function () {
        const $firstItem = $(this);
        locationLat = $firstItem.data("lat");
        locationLng = $firstItem.data("lng");
        $firstItem.addClass("active");
    });
    function initMap() {
        const location = { lat: locationLat, lng: locationLng };
        map = new google.maps.Map(document.getElementById("map"), {
            zoom: 17,
            center: location,
            controlSize: 27
        });
        marker = new google.maps.Marker({
            position: location,
            map: map,
            icon: markerImage
        });
        map.setOptions({styles: [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": "20"
                    },
                    {
                        "gamma": "1"
                    },
                    {
                        "weight": "1"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": "18"
                    },
                    {
                        "gamma": "1.00"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "gamma": "1.00"
                    },
                    {
                        "lightness": "4"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": "18"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": "-1"
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "7"
                    },
                    {
                        "gamma": "1.00"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ]});
        $(".change-marker").on("click", function () {
            const $thisMarker = $(this);
            locationLat = $thisMarker.data("lat");
            locationLng = $thisMarker.data("lng");
            $(this).addClass("active");
            $(".change-marker").not($thisMarker).removeClass("active");
            changeMarker(locationLat, locationLng);
        }); 
    }
    function changeMarker(locationX, locationY) {
        marker.setMap(null);
        marker = new google.maps.Marker({
            position: { lat: locationX, lng: locationY }, 
            map: map,
            icon: markerImage
        });
        map.setZoom(17);
        map.panTo(marker.getPosition());
    }
    window.initMap = initMap;
}


// WEBPACK FOOTER //
// ./assets/js/modules/googleMap.js